import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation User_changePassword($oldPassword: String!, $newPassword: String!, $isAdmin: Boolean, $userId: ID) {
    User_changePassword(oldPassword: $oldPassword, newPassword: $newPassword, isAdmin: $isAdmin, userId: $userId) {
      isFirstTime
      transactionStatus
    }
  }
`;

const userChangePassword = async ({ oldPassword, newPassword, isAdmin, userId }) =>
  graphql(mutation, { oldPassword, newPassword, isAdmin, userId }).then(
    // eslint-disable-next-line camelcase
    ({ User_changePassword }) => User_changePassword
  );

export default userChangePassword;
